import React from "react";

import { ISqlColumn } from "@formant/core/model/ISqlColumn";
import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import { EmptyStateContent } from "./EmptyStateContent";

export interface ILoadingProps {
    columns: ISqlColumn[] | undefined;
    rows: any[] | undefined;
    missingYAxis?: boolean;
}

export function Loading(props: ILoadingProps) {
    const { columns, rows, missingYAxis } = props;

    if (missingYAxis) {
        return <EmptyStateContent>Select a Value to Chart</EmptyStateContent>;
    }

    const noDataFound =
        columns !== undefined && rows !== undefined && rows.length === 0;

    if (noDataFound) {
        return (
            <EmptyStateContent>
                No data for selected device(s)
            </EmptyStateContent>
        );
    }

    return <LoadingIndicator visible={true} />;
}
